module.exports = __webpack_public_path__ + "img/rabcat.97dd4f07.svg";